import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

export default class RowItem extends PureComponent {
  static defaultProps = {
    imageUrl: '',
    disabled: false,
  }

  static propTypes = {
    faded: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    disabled: PropTypes.bool,
    path: PropTypes.string,
    renderLeftIcon: PropTypes.func,
    renderRightIcon: PropTypes.func,
  }

  static defaultProps = {
    renderLeftIcon: undefined,
    renderRightIcon: undefined,
    disabled: false,
    path: '',
    faded: false,
  }

  preventClick = (e) => {
    e.preventDefault();
  }

  renderLeftIcon = () => {
    const { renderLeftIcon } = this.props;
    if (renderLeftIcon) {
      return renderLeftIcon();
    }
    return <noscript />;
  }

  renderRightIcon = () => {
    const { renderRightIcon } = this.props;
    if (renderRightIcon) {
      return renderRightIcon();
    }
    return <noscript />;
  }

  render() {
    const { disabled, faded, children, path } = this.props;
    const route = disabled ? '' : path;
    const linkStyle = 'flex items-center justify-between primary pointer link mv3';
    const fadedStyle = 'o-50';

    return (
      <div>
        <Link
          to={route}
          className={classnames({
            [linkStyle]: true,
            [fadedStyle]: faded,
          })}
          {...disabled && { onClick: this.preventClick }}
        >
          <div className="pa2 w4 items-center tc">
            {this.renderLeftIcon()}
          </div>
          <div className="pa3 w-80 flex-grow-1 word-wrap">
            {children}
          </div>
          <div className="pa3 items-center tc">
            {this.renderRightIcon()}
          </div>
        </Link>
        <div className="bb w-100" />
      </div>
    );
  }
}
